export default __webpack_public_path__ + "static/7-501a2f74a4a877d5f266d523e5570a27.jpg";